import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-purple-600 to-orange-400 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">🪔</span>
              </div>
              <span className="font-bold text-xl">YinGuru</span>
            </div>
            <p className="text-gray-400">
              Empowering businesses to achieve exponential growth through proven strategies and automation.
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-lg mb-4">Contact Us</h3>
            <div className="space-y-2 text-gray-400">
              <p>📧 support@yinguru.com</p>
              <p>📞 +91-9884899080</p>
            </div>
          </div>
          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <div className="space-y-2 text-gray-400">
              <p>
                <a 
                  href="https://www.yinguru.com/termsofuse" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  Terms & Conditions
                </a>
              </p>
              <p>
                <a 
                  href="https://www.yinguru.com/privacypolicy" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  Privacy Policy
                </a>
              </p>
              <p>
                <a 
                  href="https://www.yinguru.com/refundpolicy" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  Refund Policy
                </a>
              </p>
            </div>
          </div>
        </div>
        
        {/* Disclaimer Section */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="bg-gray-700 rounded-lg p-6 mb-6">
            <h4 className="font-semibold text-lg mb-3 text-yellow-400">Disclaimer</h4>
            <p className="text-gray-300 text-sm leading-relaxed">
              This site is not a part of the Facebook™ website or Facebook™™ Inc. Additionally, This site is NOT endorsed by Facebook™ in any way. FACEBOOK is a trademark of FACEBOOK, Inc. Results shown are from real estate professionals but individual results may vary based on effort and implementation. We provide proven AI strategies and tools designed specifically for property professionals, but your success depends on your commitment to applying what you learn.
            </p>
          </div>
          
          <div className="text-center text-gray-400">
            <p>&copy;{new Date().getFullYear()} Funnelsdone LLC. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;